import { useState, type FormEvent } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/app/AuthContext";
import { useToast } from "@/app/Toast";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input, Label } from "@/components/ui/form";
import { FieldRow, Muted } from "@/components/ui/overlays";

export function AccountPage() {
  const { user } = useAuth();
  const { toast } = useToast();
  const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [saving, setSaving] = useState(false);
  async function submit(event: FormEvent) {
    event.preventDefault();
    if (form.newPassword !== form.confirmPassword) { toast("error", "New passwords do not match"); return; }
    setSaving(true);
    try {
      await api.post("/api/v1/auth/change-password", { currentPassword: form.currentPassword, newPassword: form.newPassword });
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
      toast("success", "Password changed. Other sessions were signed out.");
    } catch (error) { toast("error", error instanceof Error ? error.message : "Password change failed"); }
    finally { setSaving(false); }
  }
  return <div className="mx-auto max-w-2xl space-y-4">
    <div><h1 className="text-2xl font-semibold tracking-tight">Profile & security</h1><Muted>{user?.firstName} {user?.lastName} · {user?.email}</Muted></div>
    <Card><CardHeader><CardTitle className="text-base">Change password</CardTitle></CardHeader><CardContent>
      <form className="space-y-4" onSubmit={submit}>
        <FieldRow><Label>Current password</Label><Input required type="password" minLength={8} autoComplete="current-password" value={form.currentPassword} onChange={(e) => setForm({ ...form, currentPassword: e.target.value })} /></FieldRow>
        <FieldRow><Label>New password</Label><Input required type="password" minLength={8} autoComplete="new-password" value={form.newPassword} onChange={(e) => setForm({ ...form, newPassword: e.target.value })} /></FieldRow>
        <FieldRow><Label>Confirm new password</Label><Input required type="password" minLength={8} autoComplete="new-password" value={form.confirmPassword} onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })} /></FieldRow>
        <div className="flex justify-end"><Button disabled={saving}>{saving ? "Changing…" : "Change password"}</Button></div>
      </form>
    </CardContent></Card>
  </div>;
}
